// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../index';

import { ReadyToGoRingLinkFragmentDoc } from '../../../../../../router/fragments/readyToGoRingLink.fragment.generated';
export const ReadyToGoRingVariationsFragmentDoc = `
    fragment readyToGoRingVariations on CatalogueReadyToGoRing {
  catalogueCode
  gemType
  carat
  ...readyToGoRingLink
}
    `;